import { adicionarMeses } from '@arena/shared/schemas';
import { mesPorExtenso } from '../planos/formatos.js';
import { Botao, BotaoDeIcone } from '../ui/primitivos.jsx';

/**
 * ← Este mês → e o nome do mês: o `.nav-dia` da agenda, de mês em mês.
 *
 * `mes` é o que a PESSOA pediu (o da URL), não o da resposta que está na
 * tela: com `keepPreviousData` a tela mostra o mês anterior até o novo
 * chegar, e duas setas seguidas precisam andar dois meses a partir do
 * pedido — não repetir o mesmo passo a partir do que ainda é velho.
 */
export function NavegacaoDoMes({
  mes,
  mesAtual,
  onIrPara,
}: {
  /** "AAAA-MM" — o mês pedido. */
  mes: string;
  /** O mês corrente no fuso da arena. */
  mesAtual: string;
  onIrPara: (mes: string) => void;
}) {
  return (
    <div className="nav-dia" role="group" aria-label="Escolher o mês">
      <span className="anterior">
        <BotaoDeIcone
          icone="go"
          aria-label="Mês anterior"
          onClick={() => onIrPara(adicionarMeses(mes, -1))}
        />
      </span>
      <Botao
        variante="contorno"
        pequeno
        disabled={mes === mesAtual}
        onClick={() => onIrPara(mesAtual)}
      >
        Este mês
      </Botao>
      <BotaoDeIcone
        icone="go"
        aria-label="Mês seguinte"
        onClick={() => onIrPara(adicionarMeses(mes, 1))}
      />
      <span
        aria-live="polite"
        style={{
          minWidth: 132,
          padding: '6px 12px',
          textAlign: 'center',
          fontSize: 12.5,
          color: 'var(--txt)',
          background: 'var(--panel)',
          border: '1px solid var(--line)',
          borderRadius: 'var(--pill)',
        }}
      >
        {mesPorExtenso(mes)}
      </span>
    </div>
  );
}
